import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import React, { ComponentProps, useState } from "react";

import { ariaLabel } from "src/constants/app/aria-labels";
import { useFieldContext } from "src/hooks";

import { FormControl } from "../FormControl";

type Props = ComponentProps<typeof FormControl> & {
  inputProps?: ComponentProps<typeof OutlinedInput>["inputProps"];
};

export const PasswordField = ({ label, inputProps }: Props) => {
  const field = useFieldContext<string>();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl label={label}>
      <OutlinedInput
        id={field.name}
        label={label}
        type={showPassword ? "text" : "password"}
        error={field.state.meta.errors?.length > 0}
        value={field.state.value}
        inputProps={inputProps}
        onChange={(e) => field.handleChange(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? ariaLabel.hidePassword : ariaLabel.showPassword}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
